import { createAction } from '@reduxjs/toolkit';

const clearReducers = createAction('clearReducers');

const logout = createAction('logout');

export { clearReducers };

export { logout };
